/* global winH */

function scrollToEl(q, toTop, time) {
    var pos = $(q).offset().top,
        elH = $(q).height();
        
    if (elH < winH && !toTop) pos -= (winH - elH) / 2;
    $("html, body").animate({scrollTop: pos}, time);
}

function scrollToAnchor(hash) {
    if (hash && hash !== "") {
        try {
            document.getElementById(hash.replace("#", "")).scrollIntoView();
        } catch (err) {
            window.location.hash = hash;
        }
    }
}

function prlx() {
    var rate = 60,
        scroller = 0,
        y = 0,
        dy, sy, ey, el, em, ctn, h;
    
    el = document.querySelector(".prlx-el");
    em = document.querySelector(".prlx-em");
    if (el) {
        ctn = el.parentElement;
        _scrl();
        _trans();
        window.addEventListener("scroll", _scrl);
    }

    function _scrl() {
        scroller = rate;
        h = ctn.clientHeight;
        sy = window.scrollY;
    }
    function _trans() {
        if (scroller > 0) {
            scroller--;
            dy = (sy - y) / 1.414;
            y += dy;
            if (sy <= h) {
                if (scroller === 0) y = sy;
                ey = y / 3;
                domCbTransform(el, "translate3d(0," + ey + "px,0)");
                domCbTransform(em, "translate3d(0," + ey * 1.25 + "px,0)");
            }
        }
        rAF(_trans);
    }
}